import {Component, OnInit} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {forkJoin} from "rxjs";
import * as _ from "lodash";
import {Shipment} from "../services/shipment";
import {ShipmentRoute} from "../services/shipment-route";

@Component({
    selector: 'app-shipment-details-popup-modal',
    templateUrl: './shipment-details-popup-modal.component.html',
    styleUrls: ['./shipment-details-popup-modal.component.scss'],
    providers: [ShipmentRoutesService]
})

export class ShipmentDetailsPopupModalComponent implements OnInit {

    modal: NgbModalRef;

    loading;

    shipmentId;

    public shipment: Shipment;
    public _shipment: Shipment;

    public allShipmentRoutes: ShipmentRoute[];
    public shipmentRoutes: ShipmentRoute[];

    constructor(
        public shipmentsService: ShipmentsService,
        public shipmentRoutesService: ShipmentRoutesService,
    ) {
    }

    ngOnInit() {
        this.loadShipment();
    }

    loadShipment() {
        this.loading = true;
        forkJoin([
                this.shipmentRoutesService.getShipmentRoutes(),
                this.shipmentsService.getShipment(this.shipmentId, {combineEvents: true})
            ]
        ).subscribe(data => {
            this.allShipmentRoutes = data[0];
            this.shipment = data[1];
            this.shipmentRoutes = this.allShipmentRoutes.filter(route => route.branch === this.shipment.branch);
            this._shipment = _.cloneDeep(this.shipment);
            this.loading = false;
        });
    }

    close() {
        this.modal.close();
    }
}
